import { render, staticRenderFns } from "./ReligionChangeActivationType.vue?vue&type=template&id=ad3db6ca&"
import script from "./ReligionChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ReligionChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports